export default "__VITE_ASSET__JWiGMI9o__"